module.exports = {"220174001":"锦程街道","220174002":"东风街道","220174100":"长春汽车经济技术开发区（特殊镇）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220174.json
// module id = 614
// module chunks = 0